export const stringToNumber = (number: string, fallback: number) => {
  if (isNaN(+number)) {
    return fallback;
  } else {
    return +number;
  }
};

export const getValidNumberBetween = (number: number, min: number, max: number) => {
  if (isNaN(number) || number < min) {
    return min;
  } else if (number > max) {
    return max;
  } else {
    return number;
  }
};
